module.exports = __webpack_public_path__ + "static/img/icon5.b4ecdcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon5.png
// module id = 7p1c
// module chunks = 4